import React, { useEffect, useState } from "react";
import { Container } from "@mui/material";
import pendingapproval from "../../../assets/images/PendingApproval.png";
import {
  PendingApprovalMain,
  PendingImg,
  PendingText,
} from "./styles/PendingApprovalStyle";
import { USERINFO } from "../../../constants/apiEndPoints";
import { toast } from "react-hot-toast";
import httpRequest from "../../../axios/index";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "../../../redux/slice/user/UserSlice";
import { useNavigate } from "react-router-dom";
import Loader from "../../shared/loader";

const PendingApproval = () => {
  const UserInformation = useSelector((state) => state.auth);
  const [IsData, setIsData] = useState(false);
  const [Loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const GetUserInfo = async () => {
    try {
      setLoading(true);
      const resp = await httpRequest.get(USERINFO);

      if (resp?.status === 200) {
        const userToken = { auth_token: UserInformation?.user?.auth_token };
        const UserData = { ...resp?.data?.user, ...userToken };

        if (UserData?.status === "active" && !UserData.review_approved) {
          navigate("/profile-approved");
        } else if (
          UserData?.status === "pending" &&
          UserData?.user_type === null
        ) {
          navigate("/customer-type");
        } else if (UserData?.status === "active" && UserData.review_approved) {
          navigate("/profile-approved");
        }

        dispatch(loginSuccess(UserData));
        setIsData(true);
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setLoading(false);
    }
  };

  useEffect(() => {
    GetUserInfo();
  }, []);

  return (
    <>
      {Loading && <Loader />}
      <Container maxWidth="lg">
        <PendingApprovalMain>
          <PendingImg>
            <img src={pendingapproval} alt="pendingapproval" />
          </PendingImg>
          <PendingText>
            <h6>Pending Approval!</h6>
            <p>
              We’re evaluating your profile, please wait. We’ll notify you once
              your profile is approved.
            </p>
            <p>Thank you for your patience. Any inconvenience is regretted.</p>
          </PendingText>
        </PendingApprovalMain>
      </Container>
    </>
  );
};

export default PendingApproval;
